import { Sunrise, Compass, Heart } from "lucide-react";
import { FadeUp, SectionHeading } from "../components/motion";

const SAILINGS = [
  {
    tag: "SAILING 01",
    title: "Chaplain Renewal at Sea",
    icon: Sunrise,
    body: "A dedicated sailing for chaplains seeking rest, spiritual renewal, and fellowship. Expect optional sessions, quiet moments at sea, and time to simply enjoy the journey.",
  },
  {
    tag: "SAILING 02",
    title: "Exploring Chaplaincy at Sea",
    icon: Compass,
    body: "Designed for pastors and church elders exploring a calling to chaplaincy. A gentle introduction to chaplaincy roles, service settings, and educational pathways, with unhurried space for questions and conversation.",
  },
  {
    tag: "SAILING 03",
    title: "From Diagnosis to Goodbye: Grief and Remembrance at Sea",
    icon: Heart,
    body: "A tender sailing of reflection, remembrance, and hope, drawing on themes from From Diagnosis to Goodbye. Includes an optional celebration-of-life gathering\u2014a time to honor loved ones, share stories, and give thanks.",
  },
];

export default function Sailings() {
  return (
    <section id="sailings" data-testid="section-sailings" className="bg-parchment py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading
          tone="light-bg"
          eyebrow="Themed Sailings"
          titleLines={["Three themed sailings,", "three purposes."]}
          intro="Each themed sailing is its own dedicated cruise, with its own purpose and schedule. A light, theme-specific program spreads across 3-, 4-, or 5-day itineraries, leaving guests time to enjoy the ship and shore excursions."
        />
        <div className="mt-14 grid gap-5 lg:grid-cols-3" data-testid="sailings-grid">
          {SAILINGS.map((s, i) => (
            <FadeUp key={s.tag} delay={0.08 * i} className="h-full">
              <article
                data-testid={"sailing-card-" + (i + 1)}
                className="group flex h-full flex-col border border-navy/12 bg-cream p-8 transition-all duration-500 hover:-translate-y-1 hover:border-gold/60 hover:shadow-[0_18px_45px_rgba(11,25,44,0.08)]"
              >
                <div className="flex items-center justify-between">
                  <span className="font-mono text-[11px] tracking-[0.3em] text-gold">{s.tag}</span>
                  <s.icon size={22} strokeWidth={1.25} className="text-navy/60 transition-colors duration-500 group-hover:text-gold" aria-hidden="true" />
                </div>
                <h3 className="mt-5 font-serif text-2xl font-normal leading-snug text-navy sm:text-[1.7rem]">{s.title}</h3>
                <p className="mt-4 text-sm font-light leading-relaxed text-navy/70">{s.body}</p>
              </article>
            </FadeUp>
          ))}
        </div>
        <FadeUp delay={0.15}>
          <p className="mt-10 max-w-3xl border-l-2 border-gold/60 pl-5 text-sm leading-relaxed text-navy/70" data-testid="sailings-note">
            These are separate sailings, each with its own purpose and schedule&mdash;not different
            programs happening simultaneously on one cruise. Final dates, ships, and itineraries
            will be announced when confirmed. Joining an interest list carries no booking or
            payment.
          </p>
        </FadeUp>
      </div>
    </section>
  );
}
